export function resolveUrl(...pathFragments: string[]): string {
  const lastElement = pathFragments[pathFragments.length - 1]
  const suffix = lastElement.endsWith('/') ? '/' : ''
  return (
    pathFragments
      .map(p => {
        if (p.startsWith('/')) {
          p = p.substring(1)
        }
        if (p.endsWith('/')) {
          p = p.substring(0, p.length - 1)
        }
        return p.trim()
      })
      .filter(p => p !== '')
      .join('/') + suffix
  )
}

export function parseUrl(url: string): string {
  const queryStringStartIndex = url.indexOf('?')
  let path =
    queryStringStartIndex === -1 ? url : url.substring(0, queryStringStartIndex)
  const queryString =
    queryStringStartIndex === -1 ? '' : url.substring(queryStringStartIndex)

  const [protocol, ...rest] = path.split('://')
  const newPath = rest.join('://')
  let prefix = ''
  if (newPath) {
    prefix = `${protocol}://`
    path = newPath
  }
  const suffix = path.endsWith('/') ? '/' : ''
  return `${prefix}${resolveUrl(...path.split('/'))}${suffix}${queryString}`
}

export function isFullUrl(url: string) {
  if (url) {
    return url.startsWith('http') || url.startsWith('data:')
  }
  return false
}

export function getFileFragments(file_path?: string, num_frags = 2) {
  if (!file_path) return 'No file'
  const frags = file_path.split('/')
  return frags.slice(frags.length - num_frags).join('/')
}
